<template>
  <section class="discoverBrands">
    <div class="container">
      <div class="discoverBrands__Intro">
        <h2 v-text="data.title" />
        <p v-text="data.description" />
      </div>
  
      <div class="discoverBrands__List">
        <div v-for="item in brandsListing" class="discoverBrands__Item brandBackgroundColor" :class="[useCamelCase(item.theme_class)]">
          <Flare :srcset="item.image" size="both" width="500" height="500" crop="fill" gravity="faces" :alt="item.image" />
          
          <div class="discoverBrands__ItemInner">
            <Flare :srcset="item.logo" size="both" width="520" height="200" crop="fill" :alt="item.logo" />
            <p v-text="item.description" />
          </div>

          <nuxt-link v-if="item.sef" :to="item.sef">{{ item.name }}</nuxt-link>
        </div>
      </div>

      <button v-if="!allBrandsVisible" type="button" @click="loadAllBrands" class="discoverBrands__LoadMore">{{ $t('allBrands') }}</button>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });
  const { initialData } = useSetup();
  const { brands } = initialData.value;
  const brandsListing = ref([]);
  const allBrandsVisible = computed(() => brandsListing.value.length > 3);
  let windowResizeTimeout = null;

  onMounted(() => {
    sliceBrandsList();
    window.addEventListener('resize', sliceBrandsList);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', sliceBrandsList);
  });

  function sliceBrandsList() {
    clearTimeout(windowResizeTimeout);
    windowResizeTimeout = setTimeout(() => {
      window.innerWidth <= 768 ? brandsListing.value = brands.slice(0, 3) : brandsListing.value = brands
    }, 500);
  }

  function loadAllBrands() {
    brandsListing.value = brands;
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_discoverBrands.scss');
</style>